import { apiGetData, apiPostData } from '@/services/ApiService.js'

const state = () => ({
  instanceId: 0,
  requestId: 0,
  entityId: 0,
  addressId: 0,
  currentStep: 1,
  isDiferentTrader: false,
  hasTitle: false,
  label: '',
  trader: {
    id: 0,
    name: '-',
  },
  deliveryAddress: {
    flag_ddp: 1,
    floor: '',
    room: '',
    ward: '',
    flag_under_construction: 0,
    flag_loading_ramps: 0,
    flag_underground: 0,
    flag_freight_elevator: 1,
    freight_elevator_w_unit_id: 0,
    freight_elevator_d_unit_id: 0,
    freight_elevator_load_capacity: 0,
    freight_elevator_length: 0,
    freight_elevator_door_height: 0,
    freight_elevator_door_width: 0,
    flag_wall_demolition: 0,
    flag_external_lifting: 0,
    obs: '',
  },
  items: [],
  loadCount: 0,
})

const actions = {
  // Items
  addToLead({ dispatch, commit, state, rootGetters }, inputObj) {
    if (inputObj?.area === 'home') {
      return dispatch('sendToApi', inputObj)
    }
    return dispatch('session/recoverSession', null, { root: true }).then(() => {
      if (!rootGetters['session/getAuthStatus']) {
        return false
      }
      return dispatch('sendToApi', inputObj)
    })
  },
  sendToApi({ dispatch }, inputObj) {
    return apiPostData(`${inputObj?.area}/lead/add`, inputObj)
      .then((response) => {
        return response || { success: false }
      })
      .catch(() => {
        dispatch(
          'toaster/addNotification',
          {
            type: 'error',
            message:
              'Não foi possível enviar sua proposta agora. Tente novamente em instantes.',
            ttl: 5000,
          },
          { root: true }
        )
        return { success: false }
      })
  },
}

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
